export default __webpack_public_path__ + "static/media/icon-alert-warning-red.8b1a37ae.svg";